<template>
  <div class="majorHome">
    <div v-html="listPage5"></div>
  </div>
</template>

<script>
// import bg from "@/assets/img/learning/bg.png"; // 关于我们
import { getProfessionalCommittee } from "@/api/api.js";
export default {
  data() {
    return {
      listPage5: ""
    };
  },
  mounted() {
    this.getProfessionalCommittee();
  },
  methods: {
    getProfessionalCommittee() {
      getProfessionalCommittee().then(res => {
        if (res.code === 0) {
          // this.listPage2 = res.data;
          this.listPage5 = res.data.content;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
.majorHome {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  .item {
    width: 100%;
    margin: 0 0 20px;
    box-shadow: 0px 4px 16px 0px rgba(46, 32, 45, 0.1);
    .item-img {
      padding: 20px;
      width: 100%;
      height: 100px;
      box-sizing: border-box;
      .title {
        font-size: 23px;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        letter-spacing: 4px;
      }
      .text {
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
    .item-tr {
      display: flex;
      width: 100%;
      height: 44px;
      background: rgba(250, 250, 250, 1);
      .tr-name {
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: rgba(52, 52, 52, 1);
        line-height: 44px;
      }
    }
    .item-tr2 {
      display: flex;
      width: 100%;
      height: 40px;
      background: #fff;
      > div {
        // text-align: center;
        padding: 0 16px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(22, 81, 148, 1);
        line-height: 40px;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .item-tr-l {
      width: 105px;
      height: 100%;
      border: 1px solid #f0f0f0;
    }
    .item-tr-m {
      width: calc(100% - 235px);
      height: 100%;
      border: 1px solid #f0f0f0;
    }
    .item-tr-r {
      width: 130px;
      height: 100%;
      border: 1px solid #f0f0f0;
    }
  }
}
</style>
